// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__-8EPn","header":"Messages_header__3YuZS"};